import axios from 'axios'
import store from '@/store/index'


let protocolPrefix = process.env.NODE_ENV === 'production' ? 'https' : 'http'
let protocolPort = process.env.NODE_ENV === 'production' ? '' : ':8000'
//let hostUrl = process.env.NODE_ENV === 'production' ? 'sagrilappweb.com' : 'localhost'
let hostUrl = process.env.NODE_ENV === 'production' ? 'testsagrilapp.metalteco.com' : 'localhost'

axios.defaults.headers.common.Accept = 'application/json'

if(process.env.NODE_ENV === 'production'){
  //axios.defaults.baseURL = `${protocolPrefix}://${hostUrl}${protocolPort}/apisagrilappweb/api`
  axios.defaults.baseURL = `${protocolPrefix}://${hostUrl}${protocolPort}/apisagrilappweb/api`
}else{
  axios.defaults.baseURL = `${protocolPrefix}://${hostUrl}${protocolPort}/api`
}


const auth = {
    getUser: params => axios.post('login', { params }),
    logout: () => axios.post('logout'),
    getpermisos: id => axios.get(`getpermisos/${id}`),
    getUsers: params => axios.get('getUsers', { params }),
    guardarUser: params => axios.post('signup', { params }),
    getPerfiles: params => axios.get('getPerfiles', { params }),
    UpdateUser: params => axios.post('UpdateUser', { params }),
    guardarUserEmpresa: params => axios.post('signupEmpresa', { params }),
    asignarUserEmpresa: params => axios.post('asignarUserEmpresa', { params }),
    getNewPassword: params => axios.post('getNewPassword', { params }),

    SendResetPassword: params => axios.post('SendResetPassword', { params }),
    ResetPassword: params => axios.post('ResetPassword', { params }),
    ResetPasswordNewUser: params => axios.post('ResetPasswordNewUser', { params }),
    getUsuariosProfesional: params => axios.get('getUsuariosProfesional', { params }),

    getusuariosempresas: id => axios.get(`getusuariosempresas/${id}`),
  } 

const administracion = {
    getActividadesEconominas: params => axios.get('getActividadesEconominas', { params }),
    getDepartamentos: params => axios.get('getDepartamentos', { params }),
    getCiudadesXIdDepartamento: id => axios.get(`getCiudadesXIdDepartamento/${id}`),
    getCiudades: params => axios.get('getCiudades', { params }),
    getPaises: params => axios.get('getPaises', { params }),
    getDivisas: params => axios.get('getDivisas', { params }),
    getEmpresas: params => axios.get('getEmpresas', { params }),
    UpdateEmpresa: params => axios.post('UpdateEmpresa', { params }),

    saveMenorCuantia: params => axios.post('saveMenorCuantia', { params }),
        
    updateEstadoCumplimientomenorcuantia: function(params,adjaprobacionoficial){

      let formData = new FormData();
  
      formData.append('zipadjuntosaprobacionoficial', adjaprobacionoficial);
      formData.append('data', JSON.stringify(params));
      
  
      return new Promise(function(resolve) {
        axios.post('updateEstadoCumplimientomenorcuantia' , formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(function(res) {
  
          resolve(res)      
          
        })
        .catch(function(err) {     
  
          resolve(err)
            
        })
      })
  
  
    },

    updateEstadoMenorCuantia: function(params,adjalertalaft){

      let formData = new FormData();
  
      formData.append('zipalertalaft', adjalertalaft);
      formData.append('data', JSON.stringify(params));
      
  
      return new Promise(function(resolve) {
        axios.post('updateestadomenorcuantia' , formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(function(res) {
  
          resolve(res)      
          
        })
        .catch(function(err) {     
  
          resolve(err)
            
        })
      })
  
  
    },

    getMenorCuantiaxId: params => axios.get('getMenorCuantiaxId', { params }),
    getJuntaDirectivaxId: params => axios.get('getJuntaDirectivaxId', { params }),

    AsignarresponsableRegistrosContables: params => axios.post('AsignarresponsableRegistrosContables', { params }),
    AsignarRegistrosEmpleadosContables: params => axios.post('AsignarRegistrosEmpleadosContables', { params }),
    AsignarRegistrosNoAplicaSagrilaftContables: params => axios.post('AsignarRegistrosNoAplicaSagrilaftContables', { params }),
    
    getRegistrosEmpresaGestionar: params => axios.get('getRegistrosEmpresaGestionar', { params }),

    saveJuntaDirectiva: function(params,adjanexos){

      let formData = new FormData();
  
      formData.append('adjanexos', adjanexos);
      formData.append('data', JSON.stringify(params));
      
  
      return new Promise(function(resolve) {
        axios.post('saveJuntaDirectiva' , formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(function(res) {
  
          resolve(res)      
          
        })
        .catch(function(err) {     
  
          resolve(err)
            
        })
      })
  
  
    },   
    updateEstadoAprobacionJuntaDirectiva: params => axios.post('updateestadojuntadirectiva', { params }),

    getActividadesEconominasXCodigo: params => axios.get('getActividadesEconominasXCodigo', { params }),
    getMunicipiosxNombre: params => axios.get('getMunicipiosxNombre', { params }),
    
    updateFechaContable: params => axios.post('updateFechaContable', { params }),

    getTutoriales: params => axios.get('getTutoriales', { params }),

    updateRevisionJuntaDirectiva: function(params,adjanexos){

      let formData = new FormData();
  
      formData.append('adjanexos', adjanexos);
      formData.append('data', JSON.stringify(params));
      
  
      return new Promise(function(resolve) {
        axios.post('updateRevisionJuntaDirectiva' , formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(function(res) {
  
          resolve(res)      
          
        })
        .catch(function(err) {     
  
          resolve(err)
            
        })
      })
  
  
    },

    updateActaJuntaDirectiva: function(params,adjActa){

      let formData = new FormData();
  
      formData.append('pdfActa', adjActa);
      formData.append('data', JSON.stringify(params));
      
  
      return new Promise(function(resolve) {
        axios.post('updateActaJuntaDirectiva' , formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(function(res) {
  
          resolve(res)      
          
        })
        .catch(function(err) {     
  
          resolve(err)
            
        })
      })
  
  
    },
    
  }

const financiera = {
  getRegistrosZScore: params => axios.post('getRegistrosZScore', { params }),
  AsignarTerceroZScore: params => axios.post('AsignarTerceroZScore', { params }),
  UpdateTerceroZScore: params => axios.post('UpdateTerceroZScore', { params }),  
}

const registro = {

    getregistro: id => axios.get(`getregistro/${id}`),

    getregistroxid: params => axios.get('getregistroxid', { params }),
    getregistroxidentificacion: params => axios.get('getregistroxidentificacion', { params }),
    getregistroempresaXid: params => axios.get('getregistroempresaXid', { params }),
    getregistroempresaXemailempresa: params => axios.get('getregistroempresaXemailempresa', { params }),

    guardarRegistro: function(params,adjFirma,adjCamaraComercio,adjCCRepPer,adjEstFin,adjComAcci,adjrutact,adjdecRen,adjAutCon,adjCerBan,adjSocParMay,adjActCons){

      let formData = new FormData();
  
      formData.append('imgFirma', adjFirma);
      formData.append('pdfCamaraComercio', adjCamaraComercio);
      formData.append('pdfCCRepPer', adjCCRepPer);
      formData.append('pdfEstFin', adjEstFin);
      formData.append('pdfComAcci', adjComAcci);
      formData.append('pdfrutact', adjrutact);
      formData.append('pdfdecRen', adjdecRen);
      formData.append('pdfAutCon', adjAutCon);
      formData.append('pdfCerBan', adjCerBan);
      formData.append('pdfSocParMay', adjSocParMay);
      formData.append('pdfActCons', adjActCons);
      formData.append('data', JSON.stringify(params));
      
  
      return new Promise(function(resolve) {
        axios.post('saveregistro' , formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(function(res) {
  
          resolve(res)      
          
        })
        .catch(function(err) {     
  
          resolve(err)
            
        })
      })
  
  
    },
    updateRegistro: function(params,adjFirma,adjCamaraComercio,adjCCRepPer,adjEstFin,adjComAcci,adjrutact,adjdecRen,adjAutCon,adjCerBan,adjSocParMay,adjActCons){

      let formData = new FormData();
  
      formData.append('imgFirma', adjFirma);
      formData.append('pdfCamaraComercio', adjCamaraComercio);
      formData.append('pdfCCRepPer', adjCCRepPer);
      formData.append('pdfEstFin', adjEstFin);
      formData.append('pdfComAcci', adjComAcci);
      formData.append('pdfrutact', adjrutact);
      formData.append('pdfdecRen', adjdecRen);
      formData.append('pdfAutCon', adjAutCon);
      formData.append('pdfCerBan', adjCerBan);
      formData.append('pdfSocParMay', adjSocParMay);
      formData.append('pdfActCons', adjActCons);
      formData.append('data', JSON.stringify(params));
      
  
      return new Promise(function(resolve) {
        axios.post('updateregistro' , formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(function(res) {
  
          resolve(res)      
          
        })
        .catch(function(err) {     
  
          resolve(err)
            
        })
      })
  
  
    },
    getRegistrosEmpresaPendientes: params => axios.get('getRegistrosEmpresaPendientes', { params }),
    getRegistrosCumplimientoPendientes: params => axios.get('getRegistrosCumplimientoPendientes', { params }),
    getImagenFirma: (params, responseType) => axios.get('getImagenFirma', { params: params, responseType: responseType }),
    getPdfAdjunto: (params, responseType) => axios.get('getPdfAdjunto', { params: params, responseType: responseType }),
    getZIPAdjunto: (params, responseType) => axios.get('getZIPAdjunto', { params: params, responseType: responseType }),
    getPdfAdjuntoFirmado: (params, responseType) => axios.get('getPdfAdjuntoFirmado', { params: params, responseType: responseType }),
    getPdfAdjuntoFirmadoxId: (params, responseType) => axios.get('getPdfAdjuntoFirmadoxId', { params: params, responseType: responseType }),
    getLogoEmpresa: (params, responseType) => axios.get('getLogoEmpresa', { params: params, responseType: responseType }),
    
    AprobacionFirmaManuscrita: params => axios.post('AprobacionFirmaManuscrita', { params }),
    saveFirmaManuscrita: function(params,adjFormulario){

      let formData = new FormData();
  
      formData.append('pdfFormulario', adjFormulario);
      formData.append('data', JSON.stringify(params));
      
  
      return new Promise(function(resolve) {
        axios.post('saveFirmaManuscrita' , formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(function(res) {
  
          resolve(res)      
          
        })
        .catch(function(err) {     
  
          resolve(err)
            
        })
      })
  
  
    }, 
    UpdateCheckList: function(params,adjCompliance){

      let formData = new FormData();
  
      formData.append('zipCompliance', adjCompliance);
      formData.append('data', JSON.stringify(params));
      
  
      return new Promise(function(resolve) {
        axios.post('updateCheckList' , formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(function(res) {
  
          resolve(res)      
          
        })
        .catch(function(err) {     
  
          resolve(err)
            
        })
      })
  
  
    }, 
    
    getPDFRegistro: id => axios.get(`getPDFRegistro/${id}`),
    getpdffirmado: params => axios.post('getpdffirmado', { params }),
    downloadpdfsignio: params => axios.post('downloadpdfsignio', { params }),
    updateObservacionesReferencias: params => axios.post('updateObservacionesReferencias', { params }),
    updateestado: params => axios.post('updateestado', { params }),
    updateestadoddi: params => axios.post('updateestadoddi', { params }),

    getTotRegistrosTotales: params => axios.get('getTotRegistrosTotales', { params }),
    getDashBoardEmpresa: params => axios.get('getDashBoardEmpresa', { params }),
    getRegistrosAprobados: params => axios.get('getRegistrosAprobados', { params }),
    getRegistrosPendienteGerente: params => axios.get('getRegistrosPendienteGerente', { params }),
    getRegistrosRechazados: params => axios.get('getRegistrosRechazados', { params }),
    getRegistrosPendiente: params => axios.get('getRegistrosPendiente', { params }),
    getRegistrosEnviados: params => axios.get('getRegistrosEnviados', { params }),
    getRegistrosDevueltos: params => axios.get('getRegistrosDevueltos', { params }),
    getRegistrosActualizar: params => axios.get('getRegistrosActualizar', { params }),    
    getRegistrosMesRegistros: params => axios.get('getRegistrosMesRegistros', { params }),
    getRegistrosActualizacionMesRegistros: params => axios.get('getRegistrosActualizacionMesRegistros', { params }),
    getRegistrosEstadosRegistros: params => axios.get('getRegistrosEstadosRegistros', { params }),
    getRegistrosPendienteEmpresa: params => axios.get('getRegistrosPendienteEmpresa', { params }),
    getRegistrosCumplimientoGeneral: params => axios.get('getRegistrosCumplimientoGeneral', { params }),
    getRegistrosCumplimientoProfesionales: params => axios.get('getRegistrosCumplimientoProfesionales', { params }),

    getGeneralRegistros: params => axios.get('getGeneralRegistros', { params }),
    getGeneralRegistrosCumplimiento: params => axios.get('getGeneralRegistrosCumplimiento', { params }),

    getRegistrosTotalesPorEstado: params => axios.get('getRegistrosTotalesPorEstado', { params }),
    getRegistrosTotalesSinAsignar: params => axios.get('getRegistrosTotalesSinAsignar', { params }),

    getRegistrosCumplimientoMesRegistros: params => axios.get('getRegistrosCumplimientoMesRegistros', { params }),
    getRegistrosCumplimientoActualizacionMesRegistros: params => axios.get('getRegistrosCumplimientoActualizacionMesRegistros', { params }),
    getRegistrosCumplimientoEstadosRegistros: params => axios.get('getRegistrosCumplimientoEstadosRegistros', { params }),

    getRegistrosEmpresaRevision:params => axios.get('getRegistrosEmpresaRevision', { params }),

    updateEstadoRegistroMenorCuantia: function(params,adjCompliance){

      let formData = new FormData();
  
      formData.append('zipCompliance', adjCompliance);
      formData.append('data', JSON.stringify(params));
      
  
      return new Promise(function(resolve) {
        axios.post('updateEstadoMenorCuantia' , formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(function(res) {
  
          resolve(res)      
          
        })
        .catch(function(err) {     
  
          resolve(err)
            
        })
      })
  
  
    },
        
    saveAprobacionMenorCuantia: params => axios.post('updateaprobacionmenorcuantia', { params }),
    saveAprobacionJuntaDirectiva: params => axios.post('updateaprobacionjuntadirectiva', { params }),
    getRegistrosEmpresaRechazados: params => axios.get('getRegistrosEmpresaRechazados', { params }),

    getRegistrosCumplimientoPendientesJuntaDirectiva: params => axios.get('getRegistrosCumplimientoPendientesJuntaDirectiva', { params }),
    
    getRegistrosCumplimientoPendientesJuntaDirectivaActa: params => axios.get('getRegistrosCumplimientoPendientesJuntaDirectivaActa', { params }),

    updateinfofinanciera: params => axios.post('updateinfofinanciera', { params }),
    updateRegistroInformacionBasica: params => axios.post('updateRegistroInformacionBasica', { params }),

    updatecorreccioninformacion: params => axios.post('updatecorreccioninformacion', { params }),

    ImportarRegistro: params => axios.post('ImportarRegistro', { params }),

    ImportarMasivoRegistro: params => axios.post('ImportarMasivoRegistro', { params }),

    getRegistrosEmpresaConciliacion: params => axios.get('getRegistrosEmpresaConciliacion', { params }),

    ImportarSaldoContables:params => axios.post('ImportarSaldoContables', { params }),
    ImportarMasivoSaldoContables:params => axios.post('ImportarMasivoSaldoContables', { params }),
    
    BorrarSaldoContables:params => axios.post('DeleteSaldoContables', { params }),
    
    getCheckListxId: params => axios.get('getCheckListxId', { params }),
    getchecklistpdf: (params, responseType) => axios.get('getchecklistpdf', { params: params, responseType: responseType }),

    getVerificacionListas: params => axios.get('getVerificacionListas', { params }),

    firmardocumento: params => axios.post('firmardocumento', { params }),
    cancelarfirmardocumento: params => axios.post('cancelarfirmardocumento', { params }),

    getBitacoraxIdRegistroEmpresa: params => axios.get('getBitacoraxIdRegistroEmpresa', { params }),

    GetExcelGeneralRegistros: params => axios.get('GetExcelGeneralRegistros', { params }),
    SolicitudDesvinculacion: params => axios.post('SolicitudDesvinculacion', { params }),
    getRegistrosSolicitudDesvinculacion: params => axios.get('getRegistrosSolicitudDesvinculacion', { params }),
    AprobarDesvinculacion: params => axios.post('AprobarDesvinculacion', { params }),
    cancelarvinculacion: params => axios.post('cancelarvinculacion', { params }),

    AsignarResponsableRegistro: params => axios.post('AsignarResponsableRegistro', { params }),
    AsignarRegistrosEmpleados: params => axios.post('AsignarRegistrosEmpleados', { params }),
    AsignarRegistrosNoAplicaSagrilaft: params => axios.post('AsignarRegistrosNoAplicaSagrilaft', { params }),
    
    getRegistrosSinVinculacionMayorCuantia: params => axios.get('getRegistrosSinVinculacionMayorCuantia', { params }),
    getRegistrosSinActualizacionMayorCuantia: params => axios.get('getRegistrosSinActualizacionMayorCuantia', { params }),
    getRegistrosSinVinculacion: params => axios.get('getRegistrosSinVinculacion', { params }),
    getRegistrosSinActualizacion: params => axios.get('getRegistrosSinActualizacion', { params }),
    
    getHistoricoFirmasRegistro: params => axios.get('getHistoricoFirmasRegistro', { params }),
    getHistoricoAprobaciones: params => axios.get('getHistoricoAprobaciones', { params }),
    getArchivoxId: (params, responseType) => axios.get('getArchivoHistoricoxId', { params: params, responseType: responseType }),
    
    UpdateAdjuntos: function(params,adjCCRepPer,adjrutact,adjCamaraComercio,adjEstFin,adjdecRen,adjSocParMay){

      let formData = new FormData();
  
      formData.append('pdfCCRepPer', adjCCRepPer);
      formData.append('pdfrutact', adjrutact);
      formData.append('pdfCamaraComercio', adjCamaraComercio);
      formData.append('pdfEstFin', adjEstFin);
      formData.append('pdfdecRen', adjdecRen);
      formData.append('pdfSocParMay', adjSocParMay);
      formData.append('data', JSON.stringify(params));
      
  
      return new Promise(function(resolve) {
        axios.post('UpdateAdjuntos' , formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(function(res) {
  
          resolve(res)      
          
        })
        .catch(function(err) {     
  
          resolve(err)
            
        })
      })
  
  
    },
    getCodeudoresDeudores: params => axios.get('getCodeudoresDeudores', { params }),

  }

  axios.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
    }, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if(error.response.status === 401) {
        // redirect to login page
        store.dispatch("global/logout", 401)
    }
    return Promise.reject(error);
  });

export {
    administracion,
    registro,
    auth,
    financiera
}